import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["reportSection"];

  connect() {
    this.toggle();
  }

  toggle() {
    const checked = this.element.querySelectorAll(
      'input[name="valuation[quote_ids][]"]:checked'
    );
    const hasSelection = checked.length > 0;

    this.reportSectionTargets.forEach((el) => {
      if (hasSelection) {
        el.classList.remove("hidden");
        el.classList.add("flex");
      } else {
        el.classList.add("hidden");
        el.classList.remove("flex");
      }

      const submit = el.querySelector('button[type="submit"]');
      if (!submit) return;

      submit.disabled = !hasSelection;
      if (!hasSelection && document.activeElement === submit) submit.blur();
    });
  }
}
